import { Link, Spacer } from 'components/atoms';
import { memo } from 'react';
import { PhoneIcon } from 'components/icons';
import styles from './Contact.module.scss';

export interface ContactPhoneProps {
  phone: string;
}

export const ContactPhone = memo(({ phone }: ContactPhoneProps) => {
  return (
    <Link
      className={styles.link}
      href={`tel:${phone}`}
      leftIcon={<PhoneIcon />}
    >
      <Spacer marginLeft="7px">{phone}</Spacer>
    </Link>
  );
});
